import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import megamenuImg from "../../assets/images/megamenu-img.png";

// import images
import github from "../../assets/images/brands/github.png";
import bitbucket from "../../assets/images/brands/bitbucket.png";
import dribbble from "../../assets/images/brands/dribbble.png";
import dropbox from "../../assets/images/brands/dropbox.png";
import mail_chimp from "../../assets/images/brands/mail_chimp.png";
import slack from "../../assets/images/brands/slack.png";

import logo from "../../assets/images/logo.svg";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoSmallSvg from "../../assets/images/logo-light.png";


//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import { fetchAllNotificationList } from 'model/UserModel';
import { getTimezoneInfo } from 'helpers/GeneralHelper';

const Header = props => {
  const [search, setsearch] = useState(false);
  const [megaMenu, setmegaMenu] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const [notificationList, setNotificationList] = useState([]);
  const { timezone, offset } = getTimezoneInfo();
  useEffect(() => {
    fetchNotificationList();
  }, []);

  const fetchNotificationList = async () => {
    try {
      const response = await fetchAllNotificationList([]);
      if (response?.IsSuccess) {
        setNotificationList(response.Data || []);
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
    }
  };

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            {isMobile && (
              <>
                <div className="navbar-brand-box d-lg-none d-md-block">
                  <Link to="/" className="logo logo-dark">
                    <span className="logo-sm">
                      <img src={logoLightSvg} alt="" height="22" />
                    </span>
                  </Link>
                  <Link to="/" className="logo logo-light">
                    <span className="logo-sm">
                      <img src={logoSmallSvg} alt="" height="22" />
                    </span>
                  </Link>
                </div>

                <button
                  type="button"
                  onClick={tToggle}
                  className="btn btn-sm px-3 font-size-16 header-item"
                  id="vertical-menu-btn"
                >
                  <i className={`fa fa-fw fa-bars ${isMobile ? 'logo-mobile-png' : ''}` } />
                </button>
              </>
            )}
          </div>

          {/* Right side */}
          <div className="d-flex flex-wrap flex-md-nowrap flex-column flex-md-row align-items-start align-items-md-center ms-auto w-100">
            {/* Notifications - 80% on desktop, 100% on mobile */}
            <div className="notification-wrapper overflow-hidden d-none d-md-block w-80">
              {notificationList.length > 0 ? (
                <div className="notification-scroll text-primary fw-semibold">
                  {notificationList.slice(0, 5).map((notif, index) => (
                    <span key={index} className="me-4">
                      🔔
                      <Link to={`/notification-list`} className="me-4 notification-text-moves">
                        {notif?.NotificationMessage?.Message}
                      </Link>
                    </span>
                  ))}
                </div>
              ) : (
                // <div className="text-muted">No new notifications</div>
                null
              )}
            </div>

            {/* Timezone + Profile - 20% on desktop, 100% on mobile */}
            <div className={`d-flex align-items-center justify-content-end gap-2 ${isMobile? 'w-101' : 'w-22'}`}>
              <div className="timezone-text text-muted small text-nowrap">
                <span className="fw-semibold">Timezone: </span>
                <span className="text-dark">{timezone}</span>
              </div>
              <div>
                <ProfileMenu />
              </div>
            </div>
          </div>


        </div>
      </header>

    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
